// i18n.config.ts
import zh from "@/locales/zh-CN.json";
import zhTw from "@/locales/zh-TW.json";
import vi_VN from "@/locales/vi_VN.json";
import ja_JP from "@/locales/ja_JP.json";
import en from "@/locales/en.json";
import config from "./config/index";
// 暂时切换默认台湾语言后续修改    英文暂时使用台湾语言
export const messages = { 'zh':zhTw,'tw':zhTw,'zh-CN':zhTw,'zh-TW':zhTw,'vi_VN':vi_VN,'ja_JP':ja_JP ,'en':zhTw }
export default defineI18nConfig(() => ({

  legacy: false, // 是否兼容之前
  locale: config.defaultLocale,
  fallbackLocale:  config.defaultLocale, // 兼容不到就用zh
  messages: messages
}));
